import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_FORM_SCHEMA](state, payload) {
    state.formSchema = payload;
  },
};
